import { render } from "./WishesPage.vue?vue&type=template&id=56ae5830&scoped=true"
import script from "./WishesPage.vue?vue&type=script&lang=js"
export * from "./WishesPage.vue?vue&type=script&lang=js"

import "./WishesPage.vue?vue&type=style&index=0&id=56ae5830&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ae5830"]])

export default __exports__